<template>
  <div>
    <v-card-actions>
      <v-row class="">
        <v-col class="text-right">
          <v-btn
            :loading="loading"
            x-large
            color="success"
            @click="save"
          >
            Walk-in
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
      <v-container>
        <v-row
          no-gutters
          align="center"
          justify="end"
        >
          <v-col cols="2">
            <v-switch
              v-model="editedItem.with_iss"
              true-value="yes"
              false-value="not"
              label="Com ISS"
              @change="calcAccommodationValue"
            ></v-switch>
          </v-col>
          <v-col cols="2">
            <vuetify-money
              v-model="editedItem.accommodation_value"
              label="Valor da Hospedagem"
              disabled
              outlined
            ></vuetify-money>
          </v-col>
        </v-row>

        <v-row
          no-gutters
          class=""
        >
          <v-col cols="3">
            <v-text-field
              v-model="editedItem.car_license_plate"
              class="mr-2"
              outlined
              label="Placa Automóvel"
            ></v-text-field>
          </v-col>
          <v-col class="ml-4">
            <v-switch
              v-model="editedItem.tariff_manual"
              true-value="yes"
              false-value="not"
              label="Tarifa Manual"
            ></v-switch>
          </v-col>

          <v-col
            v-if="editedItem.tariff_manual == 'not'"
            cols="3"
          >
            <SelectTariff
              v-model="editedItem.tariff_id"
              :errors="errors.tariff_id"
              class="mr-4"
              @change="errors.tariff_id = null"
              @object="setTariffObject"
            />
          </v-col>

          <v-col
            v-if="editedItem.tariff_manual == 'yes'"
            cols="3"
          >
            <vuetify-money
              v-model="tariff_manual_value"
              :error-messages="errors.tariff_manual_value"
              outlined
              label="Tarifa"
              class="mr-4"
            />
          </v-col>

          <v-col cols="">
            <input-date
              v-model="editedItem.check_out"
              :errors="errors.check_out"
              :dense="false"
              :label="'Check-out'"
              :css="'ml-4'"
              @change="createTarif()"
            ></input-date>
          </v-col>

          <v-col>
            <v-btn
              color="primary"
              class="ml-4"
              @click="showDialogTariffExtraordinary"
            >
              <v-icon>{{ icons.mdiPencilOutline }}</v-icon>tarifas
            </v-btn>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="8">
            <AutocompleteSearchCompany
              v-model="company"
              :errors="errors.company_id"
              @change="changeCompany"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="requester"
              class="ml-4"
              outlined
              label="Solicitante"
            ></v-text-field>
          </v-col>
          <v-col>
            <vuetify-money
              v-model="editedItem.children_count"
              outlined
              type="number"
              label="Qtd. Crianças"
              :options="{ locale: 'pt-BR', length: 3, precision: 0 }"
              class="ml-4"
            />
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col
            cols="4"
            class="mr-2"
          >
            <v-select
              v-model="editedItem.transport_type"
              :items="meiosTransporte"
              item-text="label"
              item-value="codigo"
              outlined
              label="Meio de Transporte"
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="editedItem.travel_reason"
              :items="motivosViagem"
              item-text="label"
              item-value="codigo"
              outlined
              label="Motivo da Viagem"
              clearable
              hide-details
            />
          </v-col>
        </v-row>

        <v-row
          no-gutters
          class="mt-2"
        >
          <v-col cols="12">
            <TableGuest
              v-model="editedItem.guests"
              :errors="errors.guest"
            />
          </v-col>
        </v-row>

        <v-row class="mt-2">
          <v-col>
            <v-textarea
              v-model="editedItem.external_tracker"
              rows="1"
              outlined
              label="Localizador Externo"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-textarea
              v-model="editedItem.obs"
              rows="6"
              outlined
              label="Observação"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-textarea
              v-model="editedItem.internal_note"
              rows="3"
              outlined
              label="Notas Internas"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- DIALOG TARIFAS EXTRAORDINARIAS -->
    <v-dialog
      v-model="dialogTariffExtraordinary"
      persistent
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Tarifas"
          @close="dialogTariffExtraordinary = false"
        />
        <v-card-text>
          <!-- v-for=" tariff in editedItem.extraordinary_tariff   " -->
          <v-row
            v-for="(tariff, index) in extraordinary_tariff"
            :key="index"
            no-gutters
            class="mb-2"
          >
            <v-col>
              <vuetify-money
                v-model="tariff.value"
                :option="{ prefix: 'R$' }"
                dense
                outlined
                hide-details
              ></vuetify-money>
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_start)"
                label="Data Inicio"
              ></v-text-field>
              <!-- <input-date css="ml-2"  v-model="tariff.date_start" :label="'Data Inicial'" :dense="true"></input-date> -->
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_end)"
                label="Data Fim"
              ></v-text-field>
              <!-- <input-date css="ml-2"  v-model="tariff.date_end" :label="'Data Final'" :dense="true"></input-date> -->
            </v-col>
            <!-- <v-col cols="1">
                        <v-btn icon color="error" class="ml-2" @click="removeTariffExtraordinary(tariff)" >
                            <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                        </v-btn>
                    </v-col> -->
          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-btn
                rounded
                color="secondary"
                @click="addTariffExtraordinary()"
              >
                <v-icon>{{ icons.mdiPlus }}</v-icon>
                Adicionar Tarifa
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                x-large
                color="secondary"
                text
                class="mr-4"
                @click="dialogTariffExtraordinary = false"
              >
                fechar
              </v-btn>
              <v-btn
                x-large
                color="primary"
                @click="confirmExtraordinaryTariff()"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiFileExportOutline,
  mdiEmailSyncOutline,
  mdiWhatsapp,
  mdiRestore,
} from '@mdi/js'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import BarTitleDialog from '@/components/BarTitleDialog.vue'
import SelectCategoryRoom from '@/components/SelectCategoryRoom.vue'
import SelectChipMutipleRoom from '@/components/SelectChipMutipleRoom.vue'
import SelectTariff from '@/components/SelectTariff.vue'
import InputDate from '@/components/InputDate.vue'
import TableGuest from './TableGuest.vue'

import AutocompleteSearchCompany from '@/components/AutocompleteSearchCompany.vue'

export default {
  components: {
    BarTitleDialog,
    InputDate,
    TableGuest,
    AutocompleteSearchCompany,
    SelectCategoryRoom,
    SelectChipMutipleRoom,
    SelectTariff,
  },

  props: {
    room: {
      type: Object,
    },

  },
  data: () => ({
    meiosTransporte: [],
    motivosViagem: [],

    // RESEND VOUCHER
    dialogResendVoucher: false,
    dialogResendVoucherWhats: false,
    emailResendVoucher: null,
    whatsResendVoucher: null,
    loadingResendVoucher: false,

    // END RESEND VOUCHER
    loading_not: false,
    loadingSelectRoom: false,
    activeEmailVoucher: false,
    activeWhatsVoucher: false,
    dialogSave: false,
    extraordinary_tariff: [],
    tariff: {},
    dialogTariffExtraordinary: false,
    dialogDelete: false,
    loadingRooms: false,
    dialog: false,
    hasAuditToday: null,
    loading: false,
    rooms: [],
    guests: [],
    guest: {},
    tariffObject: {},
    whatsResendVoucherComp: '',
    tariff_manual_value: '',
    company: '',
    editedItem: {
      check_in: new Date().toISOString().substr(0, 10),
      check_out: '',
      company_id: '',
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    defaultItem: {
      check_in: '',
      check_out: '',
      company_id: '',
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    errors: {
      room_category_id: null,
      tariff_id: null,
      check_in: null,
      check_out: null,
      company_id: null,
      guest: null,
      room: [],
    },
    options: {},
    tab: null,
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiFileExportOutline,
      mdiEmailSyncOutline,
      mdiWhatsapp,
      mdiRestore,
    },
  }),

  watch: {
    tariff_manual_value(val) {
      this.errors.tariff_manual_value = null // limpa message de error
      this.editedItem.tariff_manual_value = val
      this.calcAccommodationValue()
    },
  },

  created() {
    this.loadAuditStatus()
    this.loadFnrhDominios()
  },

  computed: {
    ...mapGetters('reserve', ['getGuests']),
    ...mapGetters('config', {
      issRate: 'getIssRate',
    }),

    cell_phone() {
      if (this.editedItem.guest) {
        return this.editedItem.guest.cell_phone
      }
    },
    email() {
      if (this.editedItem.guest) {
        return this.editedItem.guest.email
      }
    },
    ablQtdRoom() {
      if (this.editedItem.room.length > 0) {
        return true
      }

      return false
    },
    requester: {
      get() {
        return this.editedItem.requester
      },
      set(val) {
        this.editedItem.requester = val[0].toUpperCase() + val.substring(1)
      },
    },

  },

  methods: {
    ...mapActions('reserve', ['store', 'update', 'getRooms', 'exportPdf', 'setGuests', 'verifyRoom', 'resendVoucher', 'resendWhatsVoucher', 'reOpen', 'findReserve']),
    ...mapActions('select', ['get_fnrh_dominios']),
    ...mapMutations('reserve', ['setGuests']),
    ...mapActions('reserved', ['walkIn']),
    ...mapActions('audit', ['hasAudit']),

    async loadFnrhDominios() {
      const [transport, reason] = await Promise.all([
        this.get_fnrh_dominios('meios_transporte'),
        this.get_fnrh_dominios('motivos_viagem'),
      ])
      this.meiosTransporte = transport.data
      this.motivosViagem = reason.data
    },

    inicialize() { },

    showDialogTariffExtraordinary() {
      this.dialogTariffExtraordinary = true
    },

    // addTariffExtraordinary(){
    //    this.extraordinary_tariff.push({ value:0, date_start:'', date_end:''})

    // },
    // removeTariffExtraordinary(tariff){
    //    const index = this.extraordinary_tariff.indexOf(tariff);
    //    this.extraordinary_tariff.splice(index ,1)

    // },
    async loadAuditStatus() {
      try {
        const response = await this.hasAudit()
        this.hasAuditToday = response.data?.has_audit ?? false
      } catch (error) {
        console.error('Erro ao verificar auditoria', error)
        this.hasAuditToday = false
      }
    },
    setTariffObject(object) {
      this.tariffObject = object
      this.calcAccommodationValue()
    },

    async createTarif() {
      this.errors.check_out = null
      this.errors.check_in = null

      if (!this.editedItem.check_in || !this.editedItem.check_out) {
        return
      }

      if (this.hasAuditToday === null) {
        await this.loadAuditStatus()
      }

      // Helper para formatar data sem problema de timezone
      const formatDate = date => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        return `${year}-${month}-${day}`
      }

      // Pega data de check-in da reserva (formato YYYY-MM-DD)
      const checkInStr = this.editedItem.check_in
      const checkOutStr = this.editedItem.check_out

      // Calcula diferença de dias
      const checkInDate = new Date(`${checkInStr}T00:00:00`)
      const checkOutDate = new Date(`${checkOutStr}T00:00:00`)

      if (isNaN(checkInDate) || isNaN(checkOutDate)) {
        return
      }

      const diffInMs = checkOutDate - checkInDate
      let diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24))
      if (diffInDays < 1) {
        diffInDays = 1
      }

      let value = 0
      if (this.editedItem.tariff_manual == 'yes') {
        value = Number(this.editedItem.tariff_manual_value) || 0
      } else {
        value = Number(this.tariffObject.value) || 0
      }

      const checkInDay = formatDate(checkInDate)

      const now = new Date()
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const todayStr = formatDate(today)
      const isCheckInToday = checkInDay === todayStr

      // Horário de checkout (12:00)
      const checkoutHour = 12
      const checkoutMinute = 0
      const currentHour = now.getHours()
      const currentMinute = now.getMinutes()
      const isBeforeCheckout = (currentHour < checkoutHour) || (currentHour === checkoutHour && currentMinute < checkoutMinute)

      const tariffs = []

      // LÓGICA DA PRIMEIRA DIÁRIA (apenas se check-in for HOJE E antes do checkout)
      if (isCheckInToday && isBeforeCheckout) {
        if (!this.hasAuditToday) {
          // Auditoria NÃO executada ainda: primeira diária retroativa (ontem → hoje)
          const yesterday = new Date(today)
          yesterday.setDate(yesterday.getDate() - 1)
          const yesterdayStr = formatDate(yesterday)

          tariffs.push({
            value,
            date_start: yesterdayStr,
            date_end: todayStr,
          })
        } else {
          // Auditoria JÁ executada: primeira diária parcial (hoje → hoje)
          tariffs.push({
            value,
            date_start: todayStr,
            date_end: todayStr,
          })
        }
      }

      // DEMAIS DIÁRIAS (padrão: dia → dia+1)
      const currentDate = new Date(checkInDate)
      for (let i = 0; i < diffInDays; i++) {
        const startDate = new Date(currentDate)
        const endDate = new Date(currentDate)
        endDate.setDate(endDate.getDate() + 1)

        tariffs.push({
          value,
          date_start: formatDate(startDate),
          date_end: formatDate(endDate),
        })

        currentDate.setDate(currentDate.getDate() + 1)
      }

      this.extraordinary_tariff = tariffs
      this.calcAccommodationValue()
    },

    calcAccommodationValue() {
      if (this.extraordinary_tariff != undefined || this.extraordinary_tariff > 0) {
        let result = this.extraordinary_tariff.reduce((acc, tariff) => acc + parseFloat(tariff.value), 0)

        // calc de iss
        if (this.editedItem.with_iss == 'yes') {
          if (result > 0) {
            const iss = result * this.issRate
            result += iss
          }
        }

        this.editedItem.accommodation_value = result
      }
    },

    // calcExtraordinayTariff(){

    //     const value = this.extraordinary_tariff.reduce((acc,tariff) => {
    //       const diffInMs = new Date(tariff.date_end) - new Date(tariff.date_start)
    //       const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

    //       return acc + (diffInDays * tariff.value)
    //     },0);

    //     const days = this.extraordinary_tariff.reduce((acc,tariff) => {
    //       const diffInMs = new Date(tariff.date_end) - new Date(tariff.date_start)
    //       const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

    //       return acc + diffInDays
    //     },0);

    //     // console.log({value,days})
    //     return {value,days}

    // },
    confirmExtraordinaryTariff() {
      this.calcAccommodationValue()
      this.dialogTariffExtraordinary = false
    },
    changeCompany(company) {
      this.errors.company_id = null // retirar o error
      this.errors.guest = null // retirar o error
      if (company) {
        if (company.situation == '2') {
          this.$swal({
            confirmButtonColor: '#16b1ff',
            position: 'center',
            html: '<p>' + 'Esta empresa está com o faturamento bloqueado' + '</p>',
            icon: 'warning',
            title: 'Atenção',
          })
        }
        if (company.tariff_id) {
          // se tem uma tarifa cadastrada na empres aplica no select tarifas
          this.editedItem.tariff_id = company.tariff_id
        }
      }
    },
    close() {
      this.$emit('close')
    },
    formatDate(date) {
      // const date = this.date
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },
    save() {
      if (!this.validations()) return
      if (this.company) {
        this.editedItem.company_id = this.company.id
      }

      if (this.editedItem.tariff_manual == 'yes') {
        this.editedItem.tariff_id = null
      } else {
        this.editedItem.tariff_manual_value = null
      }

      if (this.extraordinary_tariff.length > 0) {
        this.editedItem.extraordinary_tariff = this.extraordinary_tariff
      }
      this.editedItem.isGroup = false
      this.editedItem.room = this.room

      this.loading = true
      this.walkIn(this.editedItem)
        .then(response => {
          this.$emit('close') // envia evento para fechar o dialog
          this.$toast.success('Check-In realizado')
          this.$emit('updategrid') // evento atualiza a grade de quartos
        })
        .finally(() => {
          this.loading = false
        })
    },
    validations() {
      let validate = true

      // valida tarifa padrao
      if (this.editedItem.tariff_manual == 'not') {
        // se estiver abilitado para tarifa padrao
        if (this.editedItem.tariff_id == null || this.editedItem.tariff_id == undefined) {
          this.errors.tariff_id = 'Campo obrigatório'
          validate = false
        }
      }

      // valida tarifa manual
      if (this.editedItem.tariff_manual == 'yes') {
        // se estiver abilitado para tarifa padrao

        if (
          this.tariff_manual_value == null
          || this.tariff_manual_value == undefined
        ) {
          this.errors.tariff_manual_value = 'Campo obrigatório'
          validate = false
        }
      }

      // valida checkin
      if (this.editedItem.check_in == null || this.editedItem.check_in == undefined || this.editedItem.check_in == '') {
        this.errors.check_in = 'Campo obrigatório'
        validate = false
      }

      // valida data checkout
      if (
        this.editedItem.check_out == null
        || this.editedItem.check_out == undefined
        || this.editedItem.check_out == ''
      ) {
        this.errors.check_out = 'Campo obrigatório'
        validate = false
      }

      // valida se tem hopede ou empresa
      const guest = false
      const company = false
      if (this.editedItem.guests.length == 0) {
        this.errors.guest = 'Obrigatório preencher hóspede'
        validate = false
      }
      if (this.company == null || this.company == undefined || this.company == '') {
        this.errors.company_id = 'Obrigatório preencher empresa'
        validate = false
      }
      if (guest && company) {
        this.errors.guest = 'Obrigatório preencher empresa ou hóspede'
        validate = false
      }

      if (this.editedItem.children_count == null || this.editedItem.children_count == '') {
        this.editedItem.children_count = 0
      }

      return validate
    },

    addTariffExtraordinary() {
      const lastTariff = this.extraordinary_tariff.at(-1) // última tarifa
      const oneDay = 24 * 60 * 60 * 1000 // milissegundos em um dia

      // Data de início = último date_end + 1 dia
      const newDateStart = lastTariff
        ? new Date(new Date(lastTariff.date_end).getTime() + oneDay)
        : new Date()

      // Data de fim = newDateStart + 1 dia
      const newDateEnd = new Date(newDateStart.getTime() + oneDay)

      this.extraordinary_tariff.push({
        value: lastTariff ? lastTariff.value : 0,
        date_start: newDateStart.toISOString().split('T')[0],
        date_end: newDateEnd.toISOString().split('T')[0],
      })
    },

  },
}
</script>

<style scoped>
.card-tab {
  min-height: 420px;
  min-width: 736px;
}

.svg-icon {
  height: 52px;

}

.tool_table_fam {
  height: 50px;
}
</style>
